import React, { useContext, useEffect, useState } from "react";

import { withAuth } from "../../../hoc/Auth";
import {Column, Container, Wrapper} from "../../../hoc/Layout";
import {
    InputHelper,
    Select,
    InputAmountCurrencyHelper, CardNumberInputHelper
} from "../../../Components/Utils/FieldsHelper";
import SingleDatePicker from "../../../Components/Utils/SingleDatePicker";
import EmptyCard from "../../../hoc/EmptyCard";
import Button from "../../../Components/Utils/UI/Button";
import MessageContext from "../../../MessageContext";
import Api from "../../../Api";
import classes from "./styles.module.css";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import Modal from "../../../Components/Utils/Modal";
import { useHistory } from "react-router-dom";

function getPsaStatus(status) {
    switch (status) {
        case "loading":
            return <div className={classes.Disabled}>Статус загружается...</div>
        case 0:
            return <div className={classes.Disabled}>Не активен</div>
        case 1:
            return <div className={classes.Process}>Обрабатывается</div>
        case 2:
            return <div className={classes.Enabled}>Выплачено</div>
        case 3:
            return <div className={classes.Error}>Платеж отклонен</div>
        case 4:
            return <div className={classes.Error}>Ошибка</div>
        default:
            return <div className={classes.Disabled}>Не активен</div>
    }
}

function PcaEdit({ token }) {
    const psaID = useParams().ID
    const history = useHistory()
    const [contract, setContract] = useState(null)
    const [terminals, setTerminals] = useState([])
    const [psa, setPsa] = useState(null)
    const { onMessage } = useContext(MessageContext);

    const [deleteModalActive, setIsDeleteModalActive] = useState(false)

    const [form, setForm] = useState({
        docPcaName: "",
        docPcaDate: "",
        metalType: "",
        description: "",
        source: "",
        transport: "",
        amount: "",
        pan: "",
        //comment: "",
        providerId: "",
        cardHolder: "",
    });

    const [viewMode, setViewMode] = useState(false)
    const [isRequest, setIsRequest] = useState(false);
    const [_, setIsDownloading] = useState(false);

    const [tableRows, setTableRows] = useState([
        { type: "", weight: "", price: "", grossWeight: "", tareWeight: "", impurity: "" },
    ]);

    const metalTypeList = [
        { displayName: 'Чёрный', isEnabled: true, id: "0" },
        { displayName: 'Цветной', isEnabled: true, id: "1" }
    ];

    function handleDelete() {
        setIsRequest(true);
        new Api({token}).deletePsa(psaID).then((r) => {
            if (r.status === 200 || r.status === 201 || r.status === 204) {
                setViewMode(true)
                setIsDeleteModalActive(false)
                onMessage({type: 'success', message: 'ПСА успешно удален!'});
                history.push('/metal/pca')
            } else if (r.status === 400) {
                onMessage({type: 'warning', message: 'Вы не можете удалить ПСА в статусе "Обрабатывается"'});
            } else {
                onMessage({type: 'error', message: 'Упс! Что-то пошло не так. Подождите некоторое время и попробуйте снова.'});
            }
        }).finally(() => {
            setIsRequest(false)
        })
    }

    function handleDownload() {
        setIsDownloading(true)
        new Api({token}).downloadPsa(psaID).then((r) => {
            if (r.status === 200) {
                const url = window.URL.createObjectURL(
                    new Blob([r.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
                  );
                  const link = document.createElement('a');
                  link.href = url;
                  link.setAttribute(
                    'download',
                    `${psa.name}-${psa.date}.xlsx`,
                  );
                  document.body.appendChild(link);
                  link.click();
                  link.parentNode.removeChild(link);
            }
            if (r.status !== 200) {
                onMessage({type: 'error', message: 'Упс! Что-то пошло не так. Подождите некоторое время и попробуйте снова.'});
            }
        }).finally(() => {
            setIsDownloading(false)
        })
    }

    useEffect(() => {
        new Api({token}).getProjects().then((data) => {
            const providers = []
            data.map(p => p.providers.map(t => providers.push(t)))
            setTerminals(providers)
        })
        new Api({token}).getPsa(psaID).then((data) => {
            setPsa(data.data)
        })
    }, [])

    useEffect(() => {
        if (psa) {
            new Api({token}).getMetalContract(psa.psaContractId).then((data) => {
                setContract(data.data);
            })
            setForm(prev => ({
                ...prev,
                docPcaName: psa.name,
                docPcaDate: new Date(psa.date),
                metalType: metalTypeList.find(type => type.id === psa.type) || "",
                description: psa.description,
                source: psa.source,
                transport: psa.vehicle,
                amount: parseFloat(psa.amount).toFixed(2),
                pan: psa.pan,
                //comment: "",
                providerId: "",
                cardHolder: psa.cardHolder,
            }))
            setTableRows(psa.positions)
        }
    }, [psa])

    useEffect(() => {
        if (psa) {
            setForm(prev => ({
                ...prev,
                providerId: terminals.find(terminal => terminal.uuid === psa.providerId)
            }))
        }
    }, [terminals, psa])

    return (
        <Wrapper>
            <Container style={{justifyContent: 'center'}}>
                <Column width={'100%'}>
                    <EmptyCard
                        title={"FieldsHelper.label.pcaEdit"}
                        subtitle={getPsaStatus(psa ? psa.status : "loading")}
                    >
                        <div className={classes.Content}>
                            <div className={classes.Column}>
                                <div className={classes.DoubleCell}>
                                    <div className={classes.InputWrap}>
                                        <InputHelper
                                            value={contract ? contract.name : ''}
                                            placeholder={"SAMPLE_01"}
                                            fieldName={"name"}
                                            label={"FieldsHelper.label.ContractName"}
                                            changeRegexp={/[^A-Za-zА-Яа-я0-9\-\s"_№]+/g}
                                            blurRegexp={/^[A-Za-zА-Яа-я0-9\-\s"_№]/}
                                            changeMessage={"FieldsHelper.label.ContractName"}
                                            blurMessage={"FieldsHelper.label.ContractName"}
                                            isDisabled={true}
                                            isRequired
                                            autoComplete="off"
                                        />
                                    </div>

                                    <div className={classes.InputWrap}>
                                        <label className={classes.Label}>Дата контракта</label>

                                        <SingleDatePicker
                                            selected={contract ? new Date(contract.date) : ''}
                                            className={classes.Input}
                                            dateFormat="dd.MM.yyyy"
                                            placeholderText="00.00.0000"
                                            disabled={true}
                                        />
                                    </div>
                                </div>

                                <h3 className={classes.Title}>Номер и дата ПСА</h3>
                                <p className={classes.Text}>Все поля обязательны к заполнению.</p>

                                <div className={classes.DoubleCell}>
                                    <div className={classes.InputWrap}>
                                        <InputHelper
                                            value={form.docPcaName}
                                            placeholder={"SAMPLE_PCA_01"}
                                            fieldName={"docPcaName"}
                                            label={"FieldsHelper.label.PcaName"}
                                            changeRegexp={/[^A-Za-zА-Яа-я0-9\-\s"_№]+/g}
                                            blurRegexp={/^[A-Za-zА-Яа-я0-9\-\s"_№]/}
                                            changeMessage={"FieldsHelper.label.PcaName"}
                                            blurMessage={"FieldsHelper.label.PcaName"}
                                            isDisabled={true}
                                            isRequired
                                            autoComplete="off"
                                        />
                                    </div>

                                    <div className={classes.InputWrap}>
                                        <label className={classes.Label}>Дата ПСА</label>

                                        <SingleDatePicker
                                            selected={form.docPcaDate}
                                            className={classes.Input}
                                            dateFormat="dd.MM.yyyy"
                                            placeholderText="00.00.0000"
                                            disabled={true}
                                        />
                                    </div>
                                </div>

                                <h3 className={classes.Title}>Основные данные</h3>

                                <div className={classes.InputWrap}>
                                    <Select
                                        label={"FieldsHelper.label.PcaTypeMetal"}
                                        placeholder={"FieldsHelper.label.PcaTypeMetal"}
                                        values={metalTypeList}
                                        selectedValue={form.metalType}
                                        fieldName={"displayName"}
                                        fieldStatus={"isEnabled"}
                                        isLoading={true}
                                    />
                                </div>

                                <div className={classes.InputWrap}>
                                    <InputHelper
                                        value={form.description}
                                        placeholder={"Описание лома и отходов"}
                                        fieldName={"description"}
                                        label={"FieldsHelper.label.pcaDescriptionMetal"}
                                        changeRegexp={/[^А-Яа-я\-\s".№]+/g}
                                        blurRegexp={/^[А-Яа-я\-\s".№]/}
                                        changeMessage={"FieldsHelper.error.onlyLatinIssued"}
                                        blurMessage={"FieldsHelper.error.checkIssued"}
                                        isDisabled={true}
                                        isRequired
                                        autoComplete="off"
                                    />
                                </div>

                                <div className={classes.InputWrap}>
                                    <InputHelper
                                        value={form.source}
                                        placeholder={"Источник лома"}
                                        fieldName={"source"}
                                        label={"FieldsHelper.label.pcaSourceMetal"}
                                        changeRegexp={/[^А-Яа-я\-\s".№]+/g}
                                        blurRegexp={/^[А-Яа-я\-\s".№]/}
                                        changeMessage={"FieldsHelper.error.onlyLatinIssued"}
                                        blurMessage={"FieldsHelper.error.checkIssued"}
                                        isDisabled={true}
                                        isRequired
                                        autoComplete="off"
                                    />
                                </div>

                                <div className={classes.InputWrap}>
                                    <InputHelper
                                        value={form.transport}
                                        placeholder={"Марка и номер ТС"}
                                        fieldName={"transport"}
                                        label={"FieldsHelper.label.pcaTransportMetal"}
                                        changeRegexp={/[^А-Яа-я0-9\-\s".№]+/g}
                                        blurRegexp={/^[А-Яа-я0-9\-\s".№]/}
                                        changeMessage={"FieldsHelper.error.onlyLatinIssued"}
                                        blurMessage={"FieldsHelper.error.checkIssued"}
                                        isDisabled={true}
                                        isRequired
                                        autoComplete="off"
                                    />
                                </div>

                            </div>

                            <div className={classes.Column}>
                                {/* <div className={classes.InputWrap}>
                                    <InputHelper
                                        value={form.comment}
                                        placeholder={"Комментарий для ПСА"}
                                        fieldName={"comment"}
                                        label={"FieldsHelper.label.pcaComment"}
                                        changeRegexp={/[^А-Яа-я0-9\-\s".№]+/g}
                                        blurRegexp={/^[А-Яа-я0-9\-\s".№]/}
                                        changeMessage={"FieldsHelper.error.onlyLatinIssued"}
                                        blurMessage={"FieldsHelper.error.checkIssued"}
                                        isDisabled={true}
                                        isRequired
                                        autoComplete="off"
                                    />
                                </div> */}

                                <div className={classes.InputWrap}>
                                    <InputAmountCurrencyHelper
                                        value={form.amount}
                                        currency={["RUB"]}
                                        placeholder={"1960.20"}
                                        label={"FieldsHelper.label.amount"}
                                        changeMessage={"FieldsHelper.error.onlyNumbersAmount"}
                                        blurMessage={"FieldsHelper.error.checkAmount"}
                                        isDisabled={true}
                                        autoComplete="off"
                                    />
                                </div>

                                <div className={classes.InputWrap}>
                                    <CardNumberInputHelper
                                        value={form.pan}
                                        placeholder={"0000 0000 0000 0000 000"}
                                        isDisabled={true}
                                    />
                                </div>

                                <div className={classes.InputWrap}>
                                    <InputHelper
                                        value={form.cardHolder}
                                        placeholder={"IVAN IVANOV"}
                                        fieldName={"cardHolder"}
                                        label={"FieldsHelper.label.cardholder"}
                                        changeRegexp={/[^A-Za-z\s]+/g}
                                        blurRegexp={/([A-Z]+\s)+([A-Z]+)/ig}
                                        changeMessage={"FieldsHelper.error.onlyLatinCardholder"}
                                        blurMessage={"FieldsHelper.error.checkCardholderName"}
                                        isUppercase
                                        isDisabled={true}
                                        autoComplete="off"
                                    />
                                </div>

                                <div className={classes.InputWrap}>
                                    <Select
                                        label={"FieldsHelper.label.terminal"}
                                        placeholder={"FieldsHelper.label.selectTerminal"}
                                        values={terminals}
                                        selectedValue={form.providerId}
                                        fieldName={"displayName"}
                                        fieldStatus={"enabled"}
                                        isLoading={true}
                                    />
                                </div>
                                <EmptyCard title={"FieldsHelper.label.pcaDescription"}>
                                    {tableRows.map((row, index) => (
                                        <div key={index} className={classes.TableRow}>
                                            <div className={classes.Row}>
                                                <div className={classes.InputWrap}>
                                                    <InputHelper
                                                        value={row.type}
                                                        placeholder={"Вид металла"}
                                                        fieldName={"type"}
                                                        label={"FieldsHelper.label.metalType"}
                                                        changeRegexp={/[^A-Za-zА-Яа-я]+/g}
                                                        blurRegexp={/^[A-ZА-Я][A-Za-zА-Яа-я]*/}
                                                        changeMessage={"FieldsHelper.error.onlyLettersMetalType"}
                                                        blurMessage={"FieldsHelper.error.onlyLettersMetalType"}
                                                        isDisabled={true}
                                                        isRequired={true}
                                                        autoComplete={"off"}
                                                        index={index}
                                                    />
                                                </div>
                                                <div className={classes.InputWrap}>
                                                    <InputHelper
                                                        value={row.weight}
                                                        placeholder={"Вес (тн)"}
                                                        fieldName={"weight"}
                                                        label={"FieldsHelper.label.metalWeight"}
                                                        changeRegexp={/[^0-9]+/g}
                                                        blurRegexp={/^[0-9]{5}/}
                                                        changeMessage={"FieldsHelper.error.onlyNumbersMetalWeight"}
                                                        blurMessage={"FieldsHelper.error.onlyNumbersMetalWeight"}
                                                        isDisabled={true}
                                                        isRequired
                                                        autoComplete="off"
                                                        index={index}
                                                    />
                                                </div>
                                                <div className={classes.InputWrap}>
                                                    <InputHelper
                                                        value={row.price}
                                                        placeholder={"Цена (руб)"}
                                                        fieldName={"price"}
                                                        label={"FieldsHelper.label.metalPrice"}
                                                        changeRegexp={/[^0-9]+/g}
                                                        blurRegexp={/^[0-9]{5}/}
                                                        changeMessage={"FieldsHelper.error.onlyNumbersMetalPrice"}
                                                        blurMessage={"FieldsHelper.error.onlyNumbersMetalPrice"}
                                                        isDisabled={true}
                                                        isRequired
                                                        autoComplete="off"
                                                        index={index}
                                                    />
                                                </div>
                                            </div>

                                            <div className={classes.Row}>
                                                <div className={classes.InputWrap}>
                                                    <InputHelper
                                                        value={row.grossWeight}
                                                        placeholder={"Вес брутто (тн)"}
                                                        fieldName={"grossWeight"}
                                                        label={"FieldsHelper.label.metalGrossWeight"}
                                                        changeRegexp={/[^0-9]+/g}
                                                        blurRegexp={/^[0-9]{5}/}
                                                        changeMessage={"FieldsHelper.error.onlyNumbersMetalWeight"}
                                                        blurMessage={"FieldsHelper.error.onlyNumbersMetalWeight"}
                                                        isDisabled={true}
                                                        isRequired
                                                        autoComplete="off"
                                                        index={index}
                                                    />
                                                </div>
                                                <div className={classes.InputWrap}>
                                                    <InputHelper
                                                        value={row.tareWeight}
                                                        placeholder={"Вес тары (тн)"}
                                                        fieldName={"tareWeight"}
                                                        label={"FieldsHelper.label.metalTareWeight"}
                                                        changeRegexp={/[^0-9]+/g}
                                                        blurRegexp={/^[0-9]{5}/}
                                                        changeMessage={"FieldsHelper.error.onlyNumbersMetalWeight"}
                                                        blurMessage={"FieldsHelper.error.onlyNumbersMetalWeight"}
                                                        isDisabled={true}
                                                        isRequired
                                                        autoComplete="off"
                                                        index={index}
                                                    />
                                                </div>
                                                <div className={classes.InputWrap}>
                                                    <InputHelper
                                                        value={row.impurity}
                                                        placeholder={"Засоренность (%)"}
                                                        fieldName={"impurity"}
                                                        label={"FieldsHelper.label.metalImpurity"}
                                                        changeRegexp={/[^0-9]+/g}
                                                        blurRegexp={/^[0-9]{3}/}
                                                        changeMessage={"FieldsHelper.error.onlyNumbersMetalImpurity"}
                                                        blurMessage={"FieldsHelper.error.onlyNumbersMetalImpurity"}
                                                        isDisabled={true}
                                                        isRequired
                                                        autoComplete="off"
                                                        index={index}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </EmptyCard>

                                <div className={classes.InputWrap}>
                                    <Button label={"FieldsHelper.label.pcaDelete"} color={"#c23a3aff"}
                                            onClick={() => setIsDeleteModalActive(prev => !prev)} icon={"checkmark"}
                                            isDisabled={viewMode || !psa || psa.status === 1} isLoading={isRequest}/>
                                </div>
                                <div className={classes.InputWrap}>
                                    <Button label={"FieldsHelper.label.pcaDownload"} color={"#3a80c2"}
                                            onClick={handleDownload} icon={"checkmark"} isDisabled={viewMode}
                                            isLoading={isRequest}/>
                                </div>
                                <Modal
                                    onConfirm={handleDelete}
                                    onClose={() => setIsDeleteModalActive(false)}
                                    isConfirm
                                    isOpen={deleteModalActive}
                                    title="Подтверждение удаления"
                                >
                                    <div>Вы уверены, что хотите удалить выбранный ПСА?</div>
                                </Modal>
                            </div>
                        </div>
                    </EmptyCard>
                </Column>
            </Container>
        </Wrapper>
    )
}

export default withAuth(PcaEdit);



// WEBPACK FOOTER //
// ./src/PagesOfUser/Metal/PcaEdit/index.js